import Repository from "./Repository";
const vegan = "/article-detail/vegan-items";

export default {
  getVeganItems(payload) {
    return Repository.get(`${vegan}/${payload}`);
  }
};
